<template>
  <div :class="!$vuetify.breakpoint.smAndUp && 'w-100'">
    <v-card-text class="pa-0 pa-md-4 pa-lg-0">
      <div v-html="agentFeatures.replace(/(\\r)*\\n/g, '')" class="agent-features" />
      <div class="agent-types py-4">
        <span class="d-flex flex-column align-center" v-for="(value, name) in $constants.AgentLevel" :key="name">
          <AgentIcon :level="name" :large="$vuetify.breakpoint.smAndUp" />
          <p class="text-center text-capitalize mt-2" :class="$vuetify.breakpoint.smAndUp ? 'px-5' : 'px-2 text-caption'">{{ agentRankName(name) }}</p>
        </span>
      </div>
    </v-card-text>
    <v-card-actions>
      <app-button invert gradient :label="$t('label.upgrade')" class="white--text px-14 mx-auto" @click="$emit('next-step')" />
    </v-card-actions>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AgentIcon from '@/components/AgentIcon.vue'

export default {
  name: 'AgentFeatures',

  components: { AgentIcon },

  computed: {
    ...mapGetters('page', ['agentFeatures'])
  },
  methods: {
    agentRankName(val) {
      let name = ''
      console.log('NAME', val)
      switch (val.toLowerCase()) {
        case 'silver':
          name = this.$t('label.silver')
          break
        case 'gold':
          name = this.$t('label.gold')
          break
        case 'platinum':
          name = this.$t('label.platinum')
          break
        case 'executive':
          name = this.$t('label.executive')
          break
      }
      return name
    }
  }
}
</script>

<style lang="scss" scoped>
.agent-types {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

::v-deep .agent-features > p {
  margin-bottom: 0.75rem;
}
</style>
